import {Component, NgZone, OnInit, ChangeDetectionStrategy} from "@angular/core";
import {FormControl, NgForm} from "@angular/forms";
import {ActivatedRoute} from "@angular/router";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import BasePtpForm from "../base-ptp-form";
import Utils from "src/utils";
import {PerFormaAPIService} from "src/app/services/pfapi.service";

@Component({
    selector: "app-pr",
    templateUrl: "./pr.component.html",
    styleUrls: ["./pr.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PrComponent extends BasePtpForm implements OnInit {
    constructor(
        api: PerFormaAPIService,
        private route: ActivatedRoute,
        protected modal: NgbModal,
        private zone: NgZone
    ) {
        super(api, modal);
    }

    ModalOptions = {animation: false, backdropClass: "backdrop"};
    PORequest: any = {};
    NewRequest: any = {};
    POID;
    // display-only formatted date (the model keeps its raw ISO value for round-tripping)
    CreateDateDisplay = "";
    HasLocationError = true;
    HasVendorNameError = true;
    HasVendorNumberError = true;
    Submitted = false;
    Loading = false;
    Departments = [];
    ShippingLocations = [];
    Locations = [];
    ShippingLocation;
    CancelRequest = {
        CancelNotes: "",
        CancelID: 0,
        CancelType: 0
    };

    // used to store the most recently submitted note
    NoteField = new FormControl();

    Refresh() {
        this.getData();
    }

    CloseWindow = () => {
        window.parent.close();
    };

    CancelItem = (item, template) => {
        this.CancelRequest.CancelNotes = "";
        this.CancelRequest.CancelID = item.PORequestID;
        this.CancelRequest.CancelType = 0;
        this.modal.open(template, this.ModalOptions);
    };

    addNote = () => {
        const note = {
            ID: 0,
            UserName: "you",
            Note: this.NoteField.value,
            NoteTime: new Date().toJSON()
        };

        this.PORequest.Notes = [note, ...this.PORequest.Notes];

        this.NoteField.setValue("");

        //close the modal
        this.modal.dismissAll();
        // Set loading as false.
        this.Loading = false;
    };

    // Submits the add attachment form.
    addAttachment = (event?: Event) => {
        event?.preventDefault();
        const fileInput = document.getElementById("createAttachmentFile") as HTMLInputElement;
        const file = fileInput?.files?.[0];

        const fileName =
            (document.querySelector("#addAttachmentForm [name=fileName]") as HTMLInputElement)?.value ?? "";
        const fileDescription = (document.getElementById("createAttachmentDesc") as HTMLInputElement)?.value ?? "";

        this.zone.run(() => {
            // Set loading as true.
            this.Loading = true;
        });

        this.api
            .postApiPTPUploadPORequestAttachment({
                file: file,
                poRequestId: this.POID,
                fileName: fileName,
                fileDescription: fileDescription
            })
            .subscribe(() => {
                this.zone.run(() => {
                    this.initAttachments();
                });
            });
    };

    getData = () => {
        this.api.getApiPTPGetPORequest({poRequestId: this.POID}).subscribe({
            next: (data: any) => {
                // Set scope po request.
                this.PORequest = data;
                // format for display only — keep the model's raw ISO value so it round-trips on update
                this.CreateDateDisplay = Utils.FormatDate(new Date(this.PORequest.CreateDate + "Z"));

                this.HasLocationError = true;

                if (this.PORequest.Location > 0) {
                    this.HasLocationError = false;
                }

                if (this.RequiresVendorNameAndNumber(this.PORequest)) {
                    this.HasVendorNameError = true;
                    this.HasVendorNumberError = true;

                    const vendorName = this.PORequest.VendorName.trim().toLowerCase();
                    const vendorNumber = this.PORequest.VendorNumber.trim();

                    if (vendorName != "" && vendorName != "unspecified") {
                        this.HasVendorNameError = false;
                    }

                    if (vendorNumber != "") {
                        this.HasVendorNumberError = false;
                    }
                } else {
                    this.HasVendorNameError = false;
                    this.HasVendorNumberError = false;
                }

                this.SelectShippingPOLocation();

                // Set loading as false.
                this.Loading = false;

                // see if we need to scroll
                if (this.DoScroll && this.ScrollTo?.length > 0) {
                    setTimeout(() => {
                        this.ScrollToElement(this.ScrollTo);
                    }, 500);
                }
            },
            error: error => {
                this.Error(error.error);
                this.Loading = false;
            }
        });
    };

    ShowCreateWindow = tmpl => {
        this.modal.open(tmpl, this.ModalOptions);
        window.parent.scrollTo({top: 0, behavior: "smooth"});
    };

    initAttachments = () => {
        this.api.getApiPTPGetPORequest({poRequestId: this.POID}).subscribe(data => {
            //close the modal
            this.modal.dismissAll();
            // Set scope po request.
            this.PORequest.Attachments = data.Attachments;
            // Set loading as false.
            this.Loading = false;
        });
    };

    SelectShippingPOLocation = () => {
        if (!this.PORequest.Location || this.PORequest.Location < 1) {
            this.HasLocationError = true;
        } else {
            this.HasLocationError = false;
        }
    };

    ValidateVendorName = () => {
        if (this.RequiresVendorNameAndNumber(this.PORequest)) {
            const vendorName = this.PORequest.VendorName.trim().toLowerCase();
            this.HasVendorNameError = vendorName == "" || vendorName == "unspecified";
        }
    };

    ValidateVendorNumber = () => {
        if (this.RequiresVendorNameAndNumber(this.PORequest)) {
            this.HasVendorNumberError = this.PORequest.VendorNumber.trim() == "";
        }
    };

    ngOnInit(): void {
        window.addEventListener("message", event => {
            if (event?.data?.action === "SaveForm") {
                this.Update(() => {
                    let errors = false;

                    // Show notification
                    if (this.HasLocationError) {
                        this.Error("Updated: Missing Location");
                        errors = true;
                    }

                    if (this.RequiresVendorNameAndNumber(this.PORequest) && this.HasVendorNameError) {
                        this.Error("Updated: Missing Vendor Name");
                        errors = true;
                    }

                    if (this.RequiresVendorNameAndNumber(this.PORequest) && this.HasVendorNumberError) {
                        this.Error("Updated: Missing Vendor Number");
                        errors = true;
                    }

                    if (errors) {
                        this.Loading = false;
                        return;
                    }

                    window.parent.postMessage({...event.data, action: "LoadForm"});
                });
            }
        });

        // get the query params
        const params = new URL(window.location.toString()).searchParams;

        const show = params.get("show") ?? "";

        if (show != "") {
            this.DoScroll = true;
            this.ScrollTo = show;
        }

        this.api.getApiPTPGetDeptsAndLocations().subscribe(data => {
            this.Locations = data.Locations;
            this.ShippingLocations = data.Locations;
            this.Departments = data.Departments;
            this.route.queryParams.subscribe(f => {
                if (f.porequestid) {
                    this.POID = f.porequestid;
                    this.getData();
                }
            });
        });
    }

    getErrorStatus = () => {
        if (this.HasLocationError) {
            return "text-danger has-error";
        }
    };

    getVendorErrorStatus = () => {
        if (this.RequiresVendorNameAndNumber(this.PORequest)) {
            if (this.HasVendorNameError || this.HasVendorNumberError) {
                return "text-danger has-error";
            }
        }
    };

    // Updates the PO request with the scope model.
    Update = (next?: () => void) => {
        this.Submitted = true;

        let errors = false;

        if (this.RequiresVendorNameAndNumber(this.PORequest)) {
            const vendorName = this.PORequest.VendorName.trim().toLowerCase();
            const vendorNumber = this.PORequest.VendorNumber.trim();

            if (vendorName == "" || vendorName == "unspecified") {
                this.HasVendorNameError = true;
                this.Error("Missing Vendor Name");
                errors = true;
            }

            if (vendorNumber == "") {
                this.HasVendorNumberError = true;
                this.Error("Missing Vendor Number");
                errors = true;
            }
        }

        if (!this.PORequest.Location || this.PORequest.Location === 0) {
            this.Error("Missing Location");
            this.HasLocationError = true;
            errors = true;
        }

        if (this.PORequest.LineItems.some(i => i.Description == "")) {
            this.Error("Missing Line Item Description");
            errors = true;
        }

        if (this.PORequest.Notes.some(n => n.Note == "")) {
            this.Error("Missing note text");
            errors = true;
        }

        if (errors) return;

        this.Loading = true;

        this.api.postApiPTPUpdatePORequest(this.PORequest).subscribe(
            next ??
                (() => {
                    // Reload data.
                    this.getData();

                    // Show notification
                    this.Success("Updated successfully");
                })
        );
    };

    Success = message => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-expect-error
        window.parent.successAlert(message);
    };

    // show a warning message
    Error = message => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-expect-error
        window.parent.errorAlert(message);
    };

    // Removes an note from the list of notes.
    RemoveNote = note => {
        for (let i = this.PORequest.Notes.length; i--; ) {
            if (this.PORequest.Notes[i] == note) {
                this.PORequest.Notes.splice(i, 1);
                break;
            }
        }
    };

    // Removes an item from the list of line items.
    RemoveItem = item => {
        for (let i = this.PORequest.LineItems.length; i--; ) {
            if (this.PORequest.LineItems[i] == item) {
                this.PORequest.LineItems.splice(i, 1);
                break;
            }
        }
    };

    RemoveAttachment = attach => {
        this.Loading = true;
        this.api
            .getApiPTPDeletePORequestAttachment({attachmentId: attach.PurchaseRequestAttachmentID})
            .subscribe(() => {
                this.getData();
                // Show notification
                this.Success("Removed attachment");
            });
    };

    // Adds an item to the list of line items.
    AddItem = (form: NgForm, item) => {
        if (!form.valid) return;
        this.PORequest.LineItems.push({
            ID: 0,
            Description: item.Description,
            Quantity: item.Quantity,
            Price: item.Price
        });

        item.Description = "";
        item.Quantity = "";
        item.Price = "";

        this.modal.dismissAll();

        this.api.postApiPTPUpdatePORequest(this.PORequest).subscribe(() => {
            // Reload data.
            this.getData();

            // Show notification
            if (this.HasLocationError) {
                this.Error("Updated: Missing Location");
            }

            if (this.RequiresVendorNameAndNumber(this.PORequest) && this.HasVendorNameError) {
                this.Error("Updated: Missing Vendor Name");
            }

            if (this.RequiresVendorNameAndNumber(this.PORequest) && this.HasVendorNumberError) {
                this.Error("Updated: Missing Vendor Number");
            }
        });
    };

    // Gets the total of all line items.
    GetLinesItemTotal = () => {
        let total = 0;
        if (this.PORequest && this.PORequest.LineItems && this.PORequest.LineItems.length > 0) {
            for (let i = 0; i < this.PORequest.LineItems.length; i++) {
                const item = this.PORequest.LineItems[i];
                total += item.Quantity * item.Price;
            }
        }
        return total.toFixed(2);
    };

    DoCancelItem = () => {
        this.modal.dismissAll();
        this.Loading = true;

        const request = {
            ItemIDs: [this.CancelRequest.CancelID],
            Reference: String(this.CancelRequest.CancelType),
            Reference2: this.CancelRequest.CancelNotes
        };

        this.api.postApiPTPCancel(request).subscribe({
            next: data => {
                data.Messages.forEach(m => this.Success(m));

                this.CancelRequest.CancelNotes = "";
                this.CancelRequest.CancelID = 0;
                this.CancelRequest.CancelType = 0;
                this.PORequest.Canceled = true;

                this.Loading = false;
                window.close();
            },
            error: error => {
                this.Error(error.error.Message);
                this.Loading = false;
            }
        });
    };
}
